import React from 'react';
const Products = () => {
  return <section className="w-full bg-[#F5EBE0] py-16" data-id="element-233">
      <div className="container mx-auto px-4" data-id="element-234">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-6" data-id="element-235">
          Combo Gourmet: Tu Arsenal Completo
        </h2>
        <p className="text-xl text-center text-[#5E4B3C] mb-12 max-w-3xl mx-auto" data-id="element-236">
          Tres libros digitales diseñados estratégicamente para transformar tus
          eventos, además de 10 ebooks de bonos que te presentamos abajo
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-237">
          <div className="flex flex-col items-center" data-id="element-238">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mC1gXixC1iqtgHpLaopBB6/1-_Recetario_Base_Infalible%2C_2B20_Recetas_de_Finger_Foods_Gourmet_%28Mockup%29.png" alt="Recetario Base Infalible" className="w-full max-w-[250px] h-auto mb-4 rounded shadow-lg transform transition-transform hover:scale-105" data-id="element-239" />
            <h3 className="text-xl font-bold text-center text-[#8B4513] mt-4" data-id="element-240">
              Recetario Base Infalible
            </h3>
            <p className="text-center text-[#5E4B3C]" data-id="element-241">
              +20 Recetas de Finger Foods Gourmet
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-242">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vDuZbY7QxAXDZHaZiQaB48/2-_Salsas_and_Aderezos_Maestros_-_10_Mezclas_Gourmet_para_Finger_Foods_%28Mockup%29.png" alt="Salsas & Aderezos Maestros" className="w-full max-w-[250px] h-auto mb-4 rounded shadow-lg transform transition-transform hover:scale-105" data-id="element-243" />
            <h3 className="text-xl font-bold text-center text-[#8B4513] mt-4" data-id="element-244">
              Salsas & Aderezos Maestros
            </h3>
            <p className="text-center text-[#5E4B3C]" data-id="element-245">
              10 Mezclas Gourmet para Finger Foods
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-246">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q8pz7haq66NJSfEDWjSVEU/3-_Tecnicas_Expres_del_Chef_-_15_Atajos_Profesionales_para_Finger_Foods_Gourmet_%28Mockup%29.png" alt="Técnicas Exprés de Chef" className="w-full max-w-[250px] h-auto mb-4 rounded shadow-lg transform transition-transform hover:scale-105" data-id="element-247" />
            <h3 className="text-xl font-bold text-center text-[#8B4513] mt-4" data-id="element-248">
              Técnicas Exprés de Chef
            </h3>
            <p className="text-center text-[#5E4B3C]" data-id="element-249">
              15 Atajos Profesionales para Finger Foods Gourmet
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Products;